<template>
    <div id="contenedor">

        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <!-- Carga el compononte para activar modal de  ver calendario -->
        <component :is="componentCalendar" :datos="paramsTareas" @closeCalendar="closeModalCalendar"></component>

        <!-- boton crear -->
        <v-row>
            <v-col cols="12" class="d-flex justify-end">
                <TableButtonComp normalButton @click="verCalendario" v-if="botonCalendario" textButton="Ver calendario"
                    iconBut="fas fa-calendar" />
            </v-col>
        </v-row>
        <!-- fin de boton -->


        <!-- /////////////////////////////////////////////////////
            //    PANTALLA PRINCIPAL DE PROGRAMACION DOCENTE   //
        ///////////////////////////////////////////////////////////    -->
        <v-row>
            <v-col cols="12" sm="3" md="">
                <AutocompleteComp textLabel="Nivel" v-model="paramsTareas.id_nivel" :items="NivelesCoor"
                    item-value="id_nivel" item-text="desc_nivel"
                    @change="getAllGradosCoordinacion(paramsTareas.id_nivel)" />
            </v-col>

            <v-col cols="12" sm="3" md="">
                <AutocompleteComp textLabel="Grado" v-model="id_grado" :items="GradosCoor" :isDisable="inhabilitarGradoDoc"
                    item-value="id" item-text="desc_grado" @change="getAllSeccionesCoordinacion(id_grado)" />
            </v-col>
            <v-col cols="12" sm="3" md="">
                <AutocompleteComp textLabel="Sección" v-model="id_seccion" :items="SeccionesCoor"
                    :isDisable="inhabilitarSeccion" item-value="id" item-text="nombre_seccion"
                    @change="getAllAlumnosCoordinacion(id_seccion)" />
            </v-col>

            <v-col cols="12" sm="3" md="">
                <AutocompleteComp textLabel="Estudiante" v-model="id_alumno" :items="AlumnosCoor"
                    :isDisable="inhabilitarAlumnos" item-value="id" item-text="alumno"
                    @change="getAllClases(id_alumno, 'alumno')" />
            </v-col>

            <v-col cols="12" sm="3" md="">
                <AutocompleteComp textLabel="Área" v-model="id_area" :items="AreasCoor" :isDisable="inhabilitarAreaDoc"
                    item-value="id" item-text="desc_area" @change="getAllCursosCoordinador(id_area)" />
            </v-col>

            <v-col cols="12" sm="3" md="">
                <AutocompleteComp textLabel="Curso" v-model="id_curso" :items="CursosCoor" :isDisable="inhabilitarCursoDoc"
                    item-value="id" item-text="desc_curso" @change="getAllClases(id_curso, 'curso')" />
            </v-col>

        </v-row>
        <v-row>

            <v-col cols="12">
                <ComundataTablecomp :headers="SupervicionclasesCordinadoHeaders" :items="ClasesCoordinacion"
                    :search="search" whitSearch noResultsText="Sin clases por supervisar">
                    <template v-slot:fecha="{ item }">
                        <span>{{ item.fecha | filtroFecha }}</span>
                    </template>
                    <template v-slot:horaIn="{ item }">
                        <span>{{ item.hora_inicio | filtroFormatoHora }}</span>
                    </template>

                    <template v-slot:horaFin="{ item }">
                        <span>{{ item.hora_fin | filtroFormatoHora }}</span>
                    </template>

                    <template v-slot:estado="{ item }">
                        <v-chip :color="item.color_estado" class="white--text">{{ item.desc_estado
                        }}</v-chip>
                    </template>

                    <template v-slot:clase="{ item }">
                        <TableButtonComp @click="visualizarClase(item, item.tipo_contenido)" verButton
                            tooltipText="Ver clase" />
                    </template>

                    <template v-slot:claseVirtual="{ item }">
                        <TableButtonComp
                            @click="verClaseVirtual(item.enlace_virtual, item.fecha, item.hora_inicio, item.hora_fin, item.id_estado)"
                            textButton="Clase virtual" iconBut="fas fa-video"
                            :disabled="item.clase_virtual === 1 && item.id_estado_prog_docente !== 4" />

                    </template>
                    <template v-slot:claseGrabada="{ item }">
                        <TableButtonComp :href="item.clase_virtual_video_enlace" textButton="Ver grabación"
                            iconBut="fas fa-play" :disabled="item.clase_virtual_video === 0" />

                    </template>
                </ComundataTablecomp>
            </v-col>
            <v-col cosl="12">
                <v-chip  class="mx-2 programada-est" label dark >PROGRAMADAS: {{ contProgramada }}</v-chip>
                <v-chip  class="mx-2 ejecutada-est" label dark >EJECUTADAS: {{ contEjecutada }}</v-chip>
                <v-chip  class="mx-2 sinejecutar-est" label dark>SIN EJECUTAR: {{ contSinejecutar }}</v-chip>
                <v-chip  class="mx-2 reprogramada-est " label dark>REPROGRAMADAS: {{ contReprogramada }}</v-chip>
                <v-chip  class="mx-2 actualizada-est" label dark >ACTUALIZADAS: {{ contActualizada }}</v-chip>
                <v-chip label class="mx-2" color="primary" dark>TOTAL: {{ ClasesCoordinacion.length }}</v-chip>
            </v-col>
        </v-row>



        <!--
                <pre>programacion Docente: {{progDocente[0]}}</pre>
                <pre>Programar Clase: {{programarCl}}</pre>
            -->
        <!--------   pantalla principal   ------>






        <!-- ////////////////////////////////////////////////////
        //        MODAL DE SEGUIMIENTO O HISTORIAL        //
        ////////////////////////////////////////////////////    -->
        <v-dialog v-model="modal_seguimiento" persistent scrollable max-width="35%">
            <v-card>
                <v-card-title class="btn_otro">
                    <v-row class="d-flex justify-space-between py-0">
                        Seguimiento de la Clase
                        <v-btn fab dark x-small class="btn_style3" @click="modal_seguimiento = false"><v-icon
                                dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-row>
                        <v-timeline>
                            <v-timeline-item v-for="(item, i) in seguimientoClase" :key="i" :color="item.color_estado"
                                small>
                                <template v-slot:opposite>
                                    <span class="title font-weight-bold">
                                        {{ item.fec_us_ing }}
                                    </span>
                                </template>

                                <v-card class="elevation-2" width="350">
                                    <v-card-title class="headline">
                                        <v-chip dark class="font-weight-black" :color="item.color_estado">
                                            <h2>{{ item.desc_estado }}</h2>
                                        </v-chip>
                                    </v-card-title>

                                    <v-card-text>
                                        <p class="body-1">
                                            <span class="black--text">Fecha:</span> {{ item.fecha }}
                                        </p>

                                        <p class="body-1">
                                            <span class="black--text">Hora:</span> {{ item.hora_inicio }} - {{ item.hora_fin
                                            }}
                                        </p>

                                        <p class="body-1">
                                            <span class="black--text">Clase Virtual:</span> {{ item.clase_virtual_desc }}
                                        </p>

                                        <p class="body-1">
                                            <span class="black--text">Observación:</span> {{ item.observacion }}
                                        </p>

                                    </v-card-text>
                                </v-card>
                            </v-timeline-item>
                        </v-timeline>

                    </v-row>

                </v-card-text>

            </v-card>
        </v-dialog>
        <!-- fin modal de Seguimiento -->





        <!-- MODAL VISOR DE CONTENIDOS-->
        <v-dialog v-model="visor" scrollable max-width="90%">
            <v-card>
                <v-card-title class="btn_otro">
                    <v-row class="d-flex justify-space-between py-0">
                        Contenido
                        <v-btn fab dark x-small class="btn_style3" @click="cerrarVisor"><v-icon
                                dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>

                <v-divider></v-divider>


                <v-card-text class="text-center">
                    <component :is="tipoVisor" :diapositivas="api_list_contenidos"></component>
                    <!-- <ModalVisorCk1 :diapositivas="api_list_contenidos" ></ModalVisorCk1> -->
                </v-card-text>

            </v-card>
        </v-dialog>


        <component :is="compName" :estadoComp="estadoModalConfig" @close="CloseModalVisor"
            :parametros="parametroConfigVisor">
        </component>

    </div>
</template>


<script>
import axios, { API_URL } from "../../../helpers/axios"
import { mapMutations, mapGetters, mapActions } from 'vuex'
import Calendario from './components/calendarioClasesAlumnos.vue'
import { SupervicionclasesCordinadoHeaders } from '../../../helpers/headersTable'
// import visorContenidoColegio from '@/views/GestorContenido/Colegio/componentes/visorGestorContenido'
import moment from 'moment'
import visorContenido from '@/views/Manager/GestionContenido/viewGC/visorGestorContenido';
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue'
import TableButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue'
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue'
// import visorContenido from "@/views/Manager/CreadorContenido/componentes/visorGestorContenido";

export default {
    name: "clasesCoordinacion",

    components: {
        Calendario,
        visorContenido,
        AutocompleteComp,
        TableButtonComp,
        ComundataTablecomp
    },

    data: vm => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { 'id_submodulo': 26, "id_modulo": 7 }, //sud_modulo y modulo

        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////


        //validaciones de formulario
        rul: {
            required: value => !!value || 'Campo Requerido',
            inputReq: value => !!value || 'Campo Requerido',
            selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
            email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo electrónico es incorrecto',
            min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
            min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
            min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
            max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
            max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
            max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
            max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
            max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
            max40: v => (v || '').length <= 40 || 'Máximo 40 caracteres',
            max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
            max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
            max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
            max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

            email_null: value => {
                if (value == '') {
                    return false
                }
                else {
                    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                    return pattern.test(value) || 'El correo Electrónico es incorrecto'
                }
            },
        },


        ruta_api: API_URL + '/',  // ruta del servidor
        ruta_api2: API_URL,  // ruta del servidor


        // consulta principal

        // variable iniciales
        inhabilitarGradoDoc: true,
        inhabilitarAreaDoc: true,
        inhabilitarCursoDoc: true,
        inhabilitarSeccion: true,

        filtroProgDoc: [],
        nivelDoc: [],
        gradoDocFilter: [],
        areaDocFilter: [],
        cursoDocFilter: [],

        gradoDoc: [],
        areaDoc: [],
        cursoDoc: [],
        Docentes: [],


        progDocente: [],
        search: "",
        ///////////NUEVAS VARIABLES ////////////


        SupervicionclasesCordinadoHeaders,
        NivelesCoor: [],
        GradosCoor: [],
        SeccionesCoor: [],
        AlumnosCoor: [],
        AreasCoor: [],
        CursosCoor: [],

        id_grado: null,
        id_seccion: null,
        id_alumno: null,
        id_area: null,
        id_curso: null,

        ClasesCoordinacion: [],

        componentCalendar: '',
        modal_reporte: false,
        contProgramada: 0,
        contReprogramada: 0,
        contSinejecutar: 0,
        contEjecutada: 0,
        contActualizada: 0,

        botonCalendario: false,
        botonReporte: false,

        paramsTareas: {
            "id_colegio": sessionStorage.id_colegio,
            "id_ano_lectivo": sessionStorage.id_ano_lectivo,
            "id_nivel": null,
            "id_grado": null,
            "id_area": null,
            "id_curso": null,
            "id_seccion": null,
            "id_alumno": null,
            "fecha_inicio": null,
            "fecha_fin": null
        },

        /////////////////////////////////////



        // modal asociar clase
        modal_asociarClase: false,
        formTitle: '',
        asociarCl: [],   // asociar Clases
        search_asociarCl: '',

        inhabilitarNivelCl: false,
        inhabilitarGradoCl: false,
        inhabilitarAreaCl: false,
        inhabilitarCursoCl: false,
        inhabilitarAlumnos: true,



        //- ck1
        tablaCk1: true,
        clases: [],

        //- colegio
        tablaColegio: false,
        clasesColegio: [],



        nivelCont: [],
        id_nivelFiltro: '',

        gradoCont: [],
        id_gradoFiltro: [],

        gradoContFilter: [],

        areaCont: [],
        areaContFilter: [],
        id_areaFiltro: [],

        cursoCont: [],
        cursoContFilter: [],
        id_cursoFiltro: [],
        ////////////////////////////////////////





        // modal programar clase
        modal_programarClase: false,
        programarCl: { sesion_aprendizaje: null, tipo_contenido: null, clase_virtual: null, fecha: '', id_estado: '' },
        programarClCopia: [],


        inhabilitarFecha: false,
        inhabilitarHoraInicio: false,
        inhabilitarHoraFin: false,
        inhabilitarSesionAprendisaje: false,
        inhabilitarClaseVirtual: false,
        inhabilitarEnlaceVirtual: false,
        inhabilitarClaseVirtualEnlace: false,
        inhabilitarObservacion: false,

        nombreArchivoSubir: "",
        archivoSubir: null,
        evento: null,

        seccionDocFilter: [],
        seccionDoc: [],
        ///////////////////////////////////




        // modal confirmacion
        dialog_delete: false,
        desc_delete: null,
        id_delete: null,
        /////////////////////////



        // modal  de seguimiento
        modal_seguimiento: false,
        seguimientoClase: [],
        ////////////////////////////////

        // visor de contenidos
        compName: "",
        estadoModalConfig: false,
        parametroConfigVisor: [],

        // modal visor de contenidos
        visor: false,
        api_list_contenidos: [],
        tipoVisor: '',
        ///////////////////////////




        //-- funciones del date picker de fecha
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        menu2: false,

        menu3: false,
    }),



    computed: {
        ...mapGetters('login', ['componenteEvento']),

        computedDateFormatted2() {
            return this.formatDate(this.programarCl.fecha)
        },



        rules() {
            const rules = []

            if (this.programarCl.id_estado == 2 || this.programarCl.id_estado == 5 || this.programarCl.id_estado == null) {
                const rule = v => !!v || 'Campo Requerido'

                rules.push(rule)
            }

            return rules
        },
    },
    filters: {
        fechaTransform: function (string) {
            return string.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
        }
    },


    mounted() {
        //this.listarTemas();
        //this.loadMain()
        //this.getAllProfesores()
        this.getAllNivelesCoordinacion()
    },


    created() {
        this.actualizarParamentro()
    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },
        ////////////////////////////////////////////////////////
        verClaseVirtual(enlaceVirtual, fechaClase, horaInicio, horaFin) {
            //console.log('fecha clase:', fechaClase)
            /////// FUNCION PARA TRAER FECHA ACTUAL
            function ckeckTime(i) {
                if (i < 10) {
                    i = "0" + i
                }
                return i
            }

            //validamoque la fecha no se mayor ni menor
            let fecha_actual = moment().format('YYYY-MM-DD')
            //console.log('fecha actual', fecha_actual)
            if (fecha_actual < fechaClase) {
                this.setEnviarMens({ tipo: "E", mensaje: `La clase no ha iniciado`, tiempo: null })
            } else if (fecha_actual > fechaClase) {
                this.setEnviarMens({ tipo: "E", mensaje: `La clase ya culminó`, tiempo: null })
            } else {
                let hora = new Date()
                let horaHora = ckeckTime(hora.getHours());
                let horaMin = ckeckTime(hora.getMinutes())
                let horaActual = `${horaHora}:${horaMin}:00`
                var mensaje = "";
                var error = 0

                if (horaActual < horaInicio) {
                    mensaje += "La Clase no ha iniciado"
                    error = 1

                }


                if (horaActual > horaFin) {
                    mensaje += "La Clase ya culminó"
                    error = 1

                }


                if (error == 0) {
                    //this.setEnviarMens({tipo:"S", mensaje: `Activar Link`, tiempo:null})
                    window.open(enlaceVirtual)

                } else {
                    this.setEnviarMens({ tipo: "E", mensaje: `${mensaje}`, tiempo: null })

                }

            }
        },


        //// modal calendario
        ...mapMutations('progDocente', ['setActivarCalendario']),


        //  ------- input tipo fecha  --------
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        // cargar Docentes
        async getAllProfesores() {
            //id del colegio
            var id = sessionStorage.id_colegio
            try {
                let response = await axios.get("/administrativo/personal/profesorView/" + id + "");
                this.Docentes = response.data;
                //console.log(JSON.stringify(this.Profesores))
            }
            catch (error) {
                console.log(error);
            }

        },
        // componente de  calendario
        verCalendario() {
            // console.log('activando calendario')
            this.setActivarCalendario({ periodo: "", id_docente: "" })
            this.componentCalendar = 'Calendario'
        },
        /*****metodo para cerrar calendario *****/
        closeModalCalendar() {
            this.componentCalendar = '';
        },
        ///////////////////////////////////////////////////////////////////////////////
        ////   NUEVAS  FUNCIONES PARA CLASES COORDINACIONES           /////////////////
        //////////////////////////////////////////////////////////////////////////////
        //*******Cargar los Niveles  ****** */
        async getAllNivelesCoordinacion() {
            try {
                let params = {
                    id_colegio: sessionStorage.id_colegio,
                    id_ano_lectivo: sessionStorage.id_ano_lectivo,
                    id_persona: sessionStorage.id_persona
                }
                const response = await axios.post('/academico/coordinador/act/alu/niv/', params);
                this.NivelesCoor = response.data
                // console.log('Niveles del coordinador =====>'+JSON.stringify(this.NivelesCoor))
            } catch (error) {
                console.log(error);
            }
        },
        //******Cargar Grados  *************/
        async getAllGradosCoordinacion(id) {
            this.paramsTareas.id_nivel = id
            this.paramsTareas.id_grado = null
            this.id_grado = null
            this.paramsTareas.id_seccion = null
            this.id_seccion = null
            this.paramsTareas.id_alumno = null
            this.id_alumno = null
            this.paramsTareas.id_area = null
            this.id_area = null
            this.paramsTareas.id_curso = null
            this.id_curso = null
            this.inhabilitarSeccion = true
            this.inhabilitarAlumnos = true
            this.inhabilitarAreaDoc = true
            this.inhabilitarCursoDoc = true
            this.GradosCoor = []
            this.SeccionesCoor = []
            this.AlumnosCoor = []
            this.CursosCoor = []
            try {
                const response = await axios.post('/academico/coordinador/act/alu/gr/', this.paramsTareas);
                this.inhabilitarGradoDoc = false
                this.GradosCoor = response.data
                await this.getAllAreasCoordinador();
                await this.getAllSeccionesCoordinador(id)
                this.ClasesCoordinacion = []
                //this.getAllPeriodoCoordinacion()
                //console.log('los grados del coordinador===0>'+JSON.stringify(this.GradosCoor));
            } catch (error) {
                console.log(error);
            }
        },
        /******** Cargar Secciones  *******/
        async getAllSeccionesCoordinacion(id) {
            this.paramsTareas.id_seccion = null
            this.id_seccion = null
            this.paramsTareas.id_alumno = null
            this.id_alumno = null
            this.paramsTareas.id_area = null
            this.id_area = null
            this.paramsTareas.id_curso = null
            this.id_curso = null
            this.inhabilitarAlumnos = true
            this.inhabilitarAreaDoc = true
            this.inhabilitarCursoDoc = true
            this.SeccionesCoor = []
            this.AlumnosCoor = []
            try {
                this.paramsTareas.id_grado = id
                const response = await axios.post('/academico/coordinador/act/alu/sec/', this.paramsTareas);
                this.inhabilitarSeccion = false
                this.SeccionesCoor = response.data
                this.ClasesCoordinacion = []
                //console.log('LAS SECCIONES DEL  COORDINADOR==>>>'+JSON.stringify(this.SeccionesCoor))
            } catch (error) {
                console.log(error);
            }
        },
        /*********Cargar Alumnos ******** */
        async getAllAlumnosCoordinacion(id) {
            this.paramsTareas.id_area = null
            this.id_area = null
            this.paramsTareas.id_curso = null
            this.id_curso = null
            this.inhabilitarAreaDoc = false
            this.inhabilitarCursoDoc = true
            try {
                this.paramsTareas.id_seccion = id
                const response = await axios.post('/academico/coordinador/act/alu/alum/', this.paramsTareas);
                this.AlumnosCoor = response.data
                this.inhabilitarAlumnos = false
                this.ClasesCoordinacion = []
                // console.log('Los alumnos de la seccion:------>>>'+JSON.stringify(this.AlumnosCoor))
            } catch (error) {
                console.log(error);
            }

        },
        //// metodo para listar las areas //////////
        async getAllAreasCoordinador() {
            try {
                const response = await axios.post('/academico/coordinador/act/alu/ar/', this.paramsTareas);
                this.inhabilitarAreaDoc = false
                this.AreasCoor = response.data
                //console.log('las Areas del coordinador===0>'+JSON.stringify(this.AreasCoor));
            } catch (error) {
                console.log(error);
            }
        },
        async getAllCursosCoordinador(id) {
            this.paramsTareas.id_area = id
            // this.paramsProgramacion.id_adm_area = id
            this.CursosCoor = []
            this.paramsTareas.id_curso = null
            try {
                const response = await axios.post('/academico/coordinador/act/alu/cur/', this.paramsTareas);
                this.inhabilitarCursoDoc = false
                this.CursosCoor = response.data
                await this.getAllClases(id, 'area')
                //console.log('LOS CURSOS DEL COORDINADOR==00>>>'+JSON.stringify(this.CursosCoor))
            } catch (error) {
                console.log(error)
            }
        },
        //******  cargar todas las actividades  de los alumnos  *****/
        async getAllClases(id, tipo) {
            this.paramsTareas.id_area = null
            if (tipo === 'alumno') {
                this.paramsTareas.id_alumno = id
                this.CursosCoor = []
                this.id_area = null
                this.id_curso = null
            } else if (tipo === 'area') {
                this.paramsTareas.id_area = id
                this.id_curso = null
            } else if (tipo === 'curso') {
                this.paramsTareas.id_curso = id
            }
            try {
                //this.paramsProgramacion.id_personal = id
                const response = await axios.post('/academico/coordinador/act/alu/clas/', this.paramsTareas);
                this.ClasesCoordinacion = response.data
                if (this.ClasesCoordinacion.length === 0) {
                    this.botonCalendario = false
                    this.botonReporte = false
                } else {
                    this.botonReporte = true
                    this.botonCalendario = true
                    this.reporte(this.ClasesCoordinacion)
                }
                //console.log('Las actividades:------>>>'+JSON.stringify(this.ClasesCoordinacion))
            } catch (error) {
                console.log(error)
            }
        },

        CloseModalVisor() {
            this.estadoModalConfig = false
            // this.verTema = true
            this.LoadMain()
        },
        // botos para visualizar clases de la programacion de contenido
        async visualizarClase(item, tipo_contenido) {
            this.parametroConfigVisor = {
                id_clase: item.id_clase,
                evento: "visualizar",
                miniatura: false,
                id_diapositiva: 0,
                tipo_contenido: tipo_contenido == 1 ? "manager" : "administrativo"
            }
            this.estadoModalConfig = true
            this.compName = "visorContenido"

        },
        //  reporte
        reporte(item) {
            var cP = 0
            var cE = 0
            var cR = 0
            var cS = 0
            var cA = 0
            this.modal_reporte = true
            for (var i = 0; i < item.length; i++) {
                switch (item[i].id_estado) {
                    case 1:
                        cP = cP + 1;
                        break;
                    case 2:
                        cR = cR + 1;
                        break;
                    case 3:
                        cS = cS + 1;
                        break;
                    case 4:
                        cE = cE + 1;
                        break;
                    case 5:
                        cA = cA + 1;
                        break;
                    default:
                        break;
                }
            }
            // var ejecutada = cE*100/item.length;
            this.contEjecutada = cE
            //var programada  = cP*100/item.length;
            this.contProgramada = cP
            //var repro = cR*100/item.length;
            this.contReprogramada = cR
            //var sineje = cS*100/item.length;
            this.contSinejecutar = cS
            // var actualizada = cA*100/item.length;
            this.contActualizada = cA
        },
        closeModalReporte() {
            this.modal_reporte = false
            this.contSinejecutar = 0
            this.contEjecutada = 0
            this.contProgramada = 0
            this.contReprogramada = 0
            this.contActualizada = 0
        },

        ////////////////////--------FIN NUEVAS FUNCIONES -----------//////////////////

        //  ------- Cargar todos los registros principales al iniciar el componente   --------
        async loadMain() {
            try {
                let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`
                let response = await axios.get(`/academico/progDocente/getQuery${params}`)
                let data = response.data
                this.nivelDoc = data.payload.NivelDoc
                this.gradoDoc = data.payload.GradoDoc
                this.areaDoc = data.payload.AreaDoc
                this.cursoDoc = data.payload.CursoDoc
                this.seccionDoc = data.payload.SeccionDoc
                this.progDocente = data.payload.ProgDocente
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error}`, tiempo: null })
                //console.log(error)
            }
        },


        //  manejador del evento nivel de la programacion de clase
        eventNivelDoc() {
            this.inhabilitarGradoDoc = false
            this.inhabilitarAreaDoc = true
            this.inhabilitarCursoDoc = true

            // filtro y cargo los valores del grado segun el nivel
            //let filtro = this.asociarCl.id_nivel

            this.gradoDocFilter = this.gradoDoc.filter(el => el.id_nivel == this.filtroProgDoc.id_nivel)
        },


        // manejador del evento grado de la programacion de clase
        eventGradoDoc() {
            this.inhabilitarAreaDoc = false
            this.inhabilitarCursoDoc = true

            this.areaDocFilter = this.areaDoc.filter(el => el.id_grado == this.filtroProgDoc.id_grado)
        },



        // manejador del evento area de programacion de clase
        eventAreaDoc() {
            this.inhabilitarCursoDoc = false

            //this.cargarClases()
            // filtro y cargo los valores del los curso segun el grado
            this.cursoDocFilter = this.cursoDoc.filter(el => el.id_area == this.filtroProgDoc.id_area)
        },


        // manejador del evento area de programacion de clase
        eventCursoDoc() {
            this.seccionDocFilter = this.seccionDoc.filter(el => el.id_curso == this.filtroProgDoc.id_curso)


            //this.cargarClases()
            // filtro y cargo los valores del los curso segun el grado
            //this.cursoDocFilter = this.cursoDoc.filter(el=>el.id_area == this.filtroProgDoc.id_area)
        },






        // inicia la modal asociar clase
        asociarClase() {
            if (this.filtroProgDoc.id_curso == '' || this.filtroProgDoc.id_curso == null) {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe seleccionar un Curso`, tiempo: null })

            }

            else {
                this.modal_asociarClase = true
                this.formTitle = 'Asociar Clase'
                this.asociarCl = { contenidoTipo: null, id_nivel: "", id_grado: "", id_area: "", id_curso: "" },
                    this.clases = []
                this.clasesColegio = []
                this.inhabilitarNivelCl = true
                this.inhabilitarGradoCl = true
                this.inhabilitarAreaCl = true
                this.inhabilitarCursoCl = true
            }
        },


        // carga la consultas de contenido de ck1 o del colegio segun el tipo de contenido seleccinado (ck1 o colegio)
        async cargarQueryContenido() {
            try {
                this.clases = []
                this.asociarCl.id_nivel = ""
                this.asociarCl.id_grado = ""
                this.asociarCl.id_area = ""
                this.asociarCl.id_curso = ""

                this.inhabilitarNivelCl = false
                this.inhabilitarGradoCl = true
                this.inhabilitarAreaCl = true
                this.inhabilitarCursoCl = true

                // contenido clicken 1
                if (this.asociarCl.contenidoTipo == "1") {
                    this.id_nivelFiltro = 'id'
                    this.id_gradoFiltro = 'id'
                    this.id_areaFiltro = 'id'
                    this.id_cursoFiltro = 'id'


                    this.tablaCk1 = true
                    this.tablaColegio = false

                    let response = await axios.get(`/academico/progDocente/getQueryContCk1`)
                    //alert(JSON.stringify(response.data))

                    this.nivelCont = response.data.NivelCkOne
                    this.gradoCont = response.data.GradoCkOne
                    this.areaCont = response.data.AreaCkOne
                    this.cursoCont = response.data.CursoCkOne



                    // contenido del colegio
                }

                else if (this.asociarCl.contenidoTipo == "0") {
                    this.id_nivelFiltro = 'id_nivel'
                    this.id_gradoFiltro = 'id_grado'
                    this.id_areaFiltro = 'id_area'
                    this.id_cursoFiltro = 'id_curso'

                    this.tablaCk1 = false
                    this.tablaColegio = true

                    await this.cargarFiltros()

                    this.asociarCl.id_nivel = this.filtroProgDoc.id_nivel
                    this.eventNivelCl()

                    this.asociarCl.id_grado = this.filtroProgDoc.id_grado
                    this.eventGradoCl()

                    this.asociarCl.id_area = this.filtroProgDoc.id_area
                    this.eventAreaCl()

                    this.asociarCl.id_curso = this.filtroProgDoc.id_curso
                    this.cargarClases()


                    /* this.programarCl.id_grado    = this.filtroProgDoc.id_grado
                    this.programarCl.id_area     = this.filtroProgDoc.id_area
                    this.programarCl.id_curso    = this.filtroProgDoc.id_curso */


                    //var url = "/academico/progDocente/getQueryContColegio"
                }

            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error}`, tiempo: null })
            }
        },


        cargarFiltros() {
            this.nivelCont = this.nivelDoc
            this.gradoCont = this.gradoDoc
            this.areaCont = this.areaDoc
            this.cursoCont = this.cursoDoc
        },



        // carga las clases de los gestor de contenidos segun los filtros seleccionados
        async cargarClases() {

            try {
                this.asociarCl.periodo = this.datoLogin.id_ano_lectivo


                // contenido clicken 1
                if (this.asociarCl.contenidoTipo == "1") {
                    let response = await axios.post(`/academico/progDocente/getClasesCk1`, this.asociarCl)

                    this.clases = response.data

                    // contenido del colegio
                }
                else if (this.asociarCl.contenidoTipo == "0") {
                    let response = await axios.get(`/academico/progDocente/getContenidoColegio/colegio/${this.datoLogin.id_colegio}/nivel/${this.asociarCl.id_nivel}/grado/${this.asociarCl.id_grado}/area/${this.asociarCl.id_area}/curso/${this.asociarCl.id_curso}/usuario/${this.datoLogin.id}`)

                    this.clasesColegio = response.data.ContenidoColegio
                }
            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error}`, tiempo: null })
            }
        },



        //  manejador del evento nivel de la programacion de clase
        eventNivelCl() {
            this.inhabilitarGradoCl = false
            this.inhabilitarAreaCl = true
            this.inhabilitarCursoCl = true
            this.clases = []
            this.clasesColegio = []

            // filtro y cargo los valores del grado segun el nivel
            //let filtro = this.asociarCl.id_nivel
            this.gradoContFilter = this.gradoCont.filter(el => el.id_nivel == this.asociarCl.id_nivel)
        },



        // manejador del evento grado de la programacion de clase
        eventGradoCl() {
            this.inhabilitarAreaCl = false
            this.inhabilitarCursoCl = true
            this.clases = []
            this.clasesColegio = []


            if (this.asociarCl.contenidoTipo == "1") {
                this.areaContFilter = this.areaCont

                // contenido del colegio
            }

            else if (this.asociarCl.contenidoTipo == "0") {
                this.areaContFilter = this.areaCont.filter(el => el.id_grado == this.asociarCl.id_grado)
            }
        },



        // manejador del evento area de programacion de clase
        eventAreaCl() {
            this.inhabilitarCursoCl = false

            this.clases = []
            this.clasesColegio = []
            //this.cargarClases()
            // filtro y cargo los valores del los curso segun el grado
            let resultFiltroCurso = this.cursoCont.filter(el => el.id_area == this.asociarCl.id_area)
            this.cursoContFilter = resultFiltroCurso.filter(el => el.id_grado == this.asociarCl.id_grado)


        },



        limpiarForm() {
            this.programarCl = {
                id: null, sesion_aprendizaje: null, tipo_contenido: null,
                titulo: '', sub_titulo: '', nombre_tema: '', nombre_clase: '',
                id_clase: '', id_nivel: '',
                id_grado: '', id_area: '', id_curso: '', id_seccion: "", fecha: '',
                hora_inicio: '', hora_fin: '', enlace_sesion: "",
                apoyo_docente_ruta: '', apoyo_docente_nombre: '', nombre_uri: "",
                clase_virtual: null, enlace_virtual: null, clase_virtual_video: "", enlace_virtual_video_enlace: null,
                observacion: '', id_estado: null, desc_estado: '', color_estado: ''
            }

            this.archivoSubir = null

            // inhabilitar campos de porgramacion docente Agregar o editar
            this.inhabilitarFecha = false
            this.inhabilitarHoraInicio = false
            this.inhabilitarHoraFin = false
            this.inhabilitarSesionAprendisaje = false
            this.inhabilitarClaseVirtual = false
            this.inhabilitarEnlaceVirtual = false
            this.inhabilitarClaseVirtualEnlace = false
            this.inhabilitarObservacion = false

            this.$refs.formDatosProgramar.resetValidation()
        },



        // Levanta la modal para programar la clase  (agregar)
        addItem(items) {
            //alert(JSON.stringify(items))
            this.limpiarForm()

            this.programarCl.titulo = "Crear Programación de Clase"
            this.programarCl.nombre_tema = items.nombre_tema
            this.programarCl.nombre_clase = items.nombre_clase
            this.modal_programarClase = true
            this.evento = "agregar"
            this.programarCl.tipo_contenido = this.asociarCl.contenidoTipo
            this.programarCl.id_clase = items.id_clase
            this.programarCl.sesion_aprendizaje = items.sesion
            this.programarCl.clase_virtual = 0
            this.programarCl.clase_virtual_video = 0

            // parametrizacion previa de programacion docente
            this.programarCl.desc_estado = "Programada"
            this.programarCl.color_estado = "6d6d6d"
            this.programarCl.id_nivel = this.filtroProgDoc.id_nivel
            this.programarCl.id_grado = this.filtroProgDoc.id_grado
            this.programarCl.id_area = this.filtroProgDoc.id_area
            this.programarCl.id_curso = this.filtroProgDoc.id_curso
        },




        //  manejador del evento nivel de la programacion de clase
        eventNivelDocCl() {

            // filtro y cargo los valores del grado segun el nivel
            //let filtro = this.asociarCl.id_nivel
            this.gradoDocFilter = this.gradoDoc.filter(el => el.id_nivel == this.programarCl.id_nivel)
        },


        // manejador del evento grado de la programacion de clase
        eventGradoDocCl() {

            this.areaDocFilter = this.areaDoc.filter(el => el.id_grado == this.programarCl.id_grado)
        },



        // manejador del evento area de programacion de clase
        eventAreaDocCl() {
            //this.cargarClases()
            // filtro y cargo los valores del los curso segun el grado
            this.cursoDocFilter = this.cursoDoc.filter(el => el.id_area == this.programarCl.id_area)
        },


        // manejador del evento area de programacion de clase
        eventCursoDocCl() {
            this.seccionDocFilter = this.seccionDoc.filter(el => el.id_curso == this.programarCl.id_curso)

            //this.cargarClases()
            // filtro y cargo los valores del los curso segun el grado
            //this.cursoDocFilter = this.cursoDoc.filter(el=>el.id_area == this.programarCl.id_area)
        },



        // botos para visualizar clases de la programacion de contenido
        gestionContenido() {
            this.setEnviarMens({ tipo: "W", mensaje: `Modulo en Construccion por el Ing. Jose Guardia  `, tiempo: null })

        },



        // replicar la clase del docente ya programada
        async replicarClase(items) {
            await this.limpiarForm()

            this.gradoDocFilter = this.gradoDoc.filter(el => el.id_nivel == items.id_nivel)
            this.areaDocFilter = this.areaDoc.filter(el => el.id_grado == items.id_grado)
            this.cursoDocFilter = this.cursoDoc.filter(el => el.id_area == items.id_area)
            this.seccionDocFilter = this.seccionDoc.filter(el => el.id_curso == items.id_curso)

            // asignacion de variables de replicación
            this.programarCl.titulo = "Replicar Programación de clase"
            this.programarCl.nombre_tema = items.nombre_tema
            this.programarCl.nombre_clase = items.nombre_clase
            this.modal_programarClase = true
            this.evento = "agregar"
            this.programarCl.tipo_contenido = items.tipo_contenido
            this.programarCl.desc_estado = items.desc_estado
            this.programarCl.color_estado = items.color_estado

            //asociarCl.contenidoTipo
            this.programarCl.id_clase = items.id_clase
            this.programarCl.sesion_aprendizaje = items.sesion
            this.programarCl.id_nivel = items.id_nivel
            this.programarCl.id_grado = items.id_grado
            this.programarCl.id_area = items.id_area
            this.programarCl.id_curso = items.id_curso

            this.programarCl.clase_virtual = 0
            this.programarCl.clase_virtual_video = 0
            /* this.programarCl.clase_virtual  = items.clase_virtual
            this.programarCl.enlace_virtual = items.enlace_virtual */
        },



        async verSeguimiento(id) {
            this.modal_seguimiento = true

            let response = await axios.get("/academico/progDocente/getSeguimiento/" + id)
            this.seguimientoClase = response.data.payload.Seguimiento
        },



        // Levanta la modal para programar la clase  (agregar)
        editItem(items) {
            this.limpiarForm()

            this.gradoDocFilter = this.gradoDoc.filter(el => el.id_nivel == items.id_nivel)
            this.areaDocFilter = this.areaDoc.filter(el => el.id_grado == items.id_grado)
            this.cursoDocFilter = this.cursoDoc.filter(el => el.id_area == items.id_area)
            this.seccionDocFilter = this.seccionDoc.filter(el => el.id_curso == items.id_curso)


            // asignacion de variables de replicación
            this.programarCl.titulo = "Editar Programación de clase"
            this.programarCl.id = items.id
            this.programarCl.nombre_tema = items.nombre_tema
            this.programarCl.nombre_clase = items.nombre_clase
            this.modal_programarClase = true
            this.evento = "editar"
            this.programarCl.tipo_contenido = items.tipo_contenido
            this.programarCl.uri = this.ruta_api + items.apoyo_docente_ruta + items.apoyo_docente_nombre
            this.programarCl.enlace_sesion = items.enlace_virtual

            //asociarCl.contenidoTipo
            this.programarCl.id_clase = items.id_clase
            this.programarCl.sesion_aprendizaje = items.sesion
            this.programarCl.id_nivel = items.id_nivel
            this.programarCl.id_grado = items.id_grado
            this.programarCl.id_area = items.id_area
            this.programarCl.id_curso = items.id_curso
            this.programarCl.id_seccion = items.id_seccion
            this.programarCl.clase_virtual = items.clase_virtual
            this.programarCl.enlace_virtual = items.enlace_virtual
            this.programarCl.clase_virtual_video = items.clase_virtual_video
            this.programarCl.clase_virtual_video_enlace = items.clase_virtual_video_enlace
            this.programarCl.fecha = items.fecha
            this.programarCl.hora_inicio = items.hora_inicio
            this.programarCl.hora_fin = items.hora_fin
            this.programarCl.desc_estado = items.desc_estado
            this.programarCl.color_estado = items.color_estado
            this.programarCl.id_estado = 5

            // Bloquear Campos de programacion docente
            this.inhabilitarFecha = true
            this.inhabilitarHoraInicio = false
            this.inhabilitarHoraFin = false
            this.inhabilitarSesionAprendisaje = false
            this.inhabilitarClaseVirtual = false
            this.inhabilitarEnlaceVirtual = false
            this.inhabilitarClaseVirtualEnlace = true
            this.inhabilitarObservacion = false

            this.programarClCopia = items

            this.actualizarDatos()
        },



        actualizarDatos() {
            this.programarCl.fecha = this.programarClCopia.fecha
            this.programarCl.hora_inicio = this.programarClCopia.hora_inicio
            this.programarCl.hora_fin = this.programarClCopia.hora_fin
            this.programarCl.clase_virtual = this.programarClCopia.clase_virtual
            this.programarCl.enlace_virtual = this.programarClCopia.enlace_virtual
            this.programarCl.clase_virtual_video = this.programarClCopia.clase_virtual_video
            this.programarCl.enlace_virtual_video_enlace = this.programarClCopia.enlace_virtual_video_enlace
            this.archivoSubir = null
        },




        // manejador del evento para la edición (Actualizar)
        eventActualizar() {
            // habilito todos los campos
            this.inhabilitarFecha = true

            this.inhabilitarHoraInicio = false
            this.inhabilitarHoraFin = false
            this.inhabilitarSesionAprendisaje = false
            this.inhabilitarClaseVirtual = false
            this.inhabilitarEnlaceVirtual = false
            this.inhabilitarClaseVirtualEnlace = false
            this.inhabilitarObservacion = false

            this.actualizarDatos()
        },



        // manejador del evento para la edición (reprogramar)
        eventReprogramar() {
            // habilito todos los campos

            this.inhabilitarFecha = false
            this.inhabilitarHoraInicio = false
            this.inhabilitarHoraFin = false
            this.inhabilitarSesionAprendisaje = false
            this.inhabilitarClaseVirtual = false
            this.inhabilitarEnlaceVirtual = false
            this.inhabilitarClaseVirtualEnlace = true
            this.inhabilitarObservacion = false

            this.actualizarDatos()
        },



        // manejador del evento para la edición (reprogramar)
        async eventEjecutar() {
            this.habilitarSave = true

            // Bloquear Campos de programacion docente
            this.inhabilitarFecha = true
            this.inhabilitarHoraInicio = true
            this.inhabilitarHoraFin = true
            this.inhabilitarSesionAprendisaje = true
            this.inhabilitarClaseVirtual = true
            this.inhabilitarEnlaceVirtual = true
            this.inhabilitarClaseVirtualEnlace = false
            this.inhabilitarObservacion = false

            await this.actualizarDatos()

            // activo el video virtual
            if (this.programarCl.id_estado == 4 && this.programarCl.clase_virtual == 1) {

                this.programarCl.clase_virtual_video = 1

            }


        },



        async saveItem() {
            //this.setEnviarMens({tipo:"W", mensaje: `Guardar Archivo`, tiempo:null})
            if (this.$refs.formDatosProgramar.validate()) {

                try {
                    //let params = this.datos
                    this.programarCl.periodo = this.datoLogin.id_ano_lectivo
                    this.programarCl.usuario = this.datoLogin.id
                    this.programarCl.id_colegio = this.datoLogin.id_colegio

                    var res = ""
                    if (this.evento == 'agregar') {
                        res = await axios.post("/academico/progDocente/", this.programarCl)
                    }

                    if (this.evento == 'editar') {
                        res = await axios.put("/academico/progDocente/" + this.programarCl.id, this.programarCl)
                        //    var res = await axios.put("/sistema/usuarioManager/"+this.datos.id,this.datos)
                    }

                    this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: null })

                    if (res.data.messageT == "S") {
                        this.modal_programarClase = false
                        this.cargarClases()
                        this.loadMain()

                        // si existe un archivo se sube y se actualiza la nueva uri
                        if (this.archivoSubir) {
                            this.saveFile(res.data.lastInsert)
                        }
                    }
                }

                catch (error) {
                    this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                }
            }
        },


        async saveFile(id) {
            if (!this.archivoSubir) {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe subir un archivo `, tiempo: null })
            }

            else {
                try {
                    let formData = new FormData()
                    formData.append('subirArchivo', this.archivoSubir)
                    formData.append('usuario', this.datoLogin.id)
                    formData.append('colegio', this.datoLogin.id_colegio)
                    formData.append('periodo', this.datoLogin.id_ano_lectivo)
                    formData.append('nivel', this.programarCl.id_nivel)
                    formData.append('grado', this.programarCl.id_grado)
                    formData.append('seccion', this.programarCl.id_seccion)
                    formData.append('curso', this.programarCl.id_curso)
                    formData.append('id_programacion', id)

                    await axios.post('/academico/progDocente/addSesionAprendisaje',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    )

                    // this.setEnviarMens({tipo:response.data.messageT, mensaje: `${response.data.message}`, tiempo:null})
                    this.modal_programarClase = false
                }

                catch (error) {
                    this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })

                }
            }
        },

        // activa la modal para confirmar el borrar el registro
        deleteConfirm(items) {
            this.dialog_delete = true
            this.id_delete = items.id
            this.desc_delete = `Tema: ${items.nombre_tema}, fecha:${items.fecha},Hora ${items.hora_inicio} - (${items.id})`
        },



        //------------BORRAR Registro -------------
        async deleteItem() {
            this.dialog_delete = false
            try {
                let resp = await axios.delete("/academico/progDocente/" + this.id_delete)
                this.loadMain()
                this.dialog = false
                this.setEnviarMens({ tipo: resp.data.messageT, mensaje: resp.data.message, tiempo: null })
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },

        // funcion para cerrar modal
        cerrarVisor() {
            this.visor = false;
            this.api_list_contenidos = []
            this.tipoVisor = ''
            //this.setCloseVisor()
        },


    }
};
</script>
